<template>
  <div class="appMainWrap">
    <div class="goTop" @click="scrollToTop" v-if="goBtnFlag"></div>
    <div class="mainStLstHeader">
      <div class="mainBackBtnLogo">
        <div class="mainStLstBackBtn" @click="backBtn"></div>
        <div class="mainStLstLogo"></div>
      </div>
      <div class="mainStLstHeaderIco">
        <div class='langwrap'>
          <div class='btnNavi langNavi langDisabled' v-if="this.isGlobalButtonEnabled()">
            <span
              @click="toggleLangBox()"
              class="ico lang"
              :class="{ ko: isKo, en: isEn, cn: isCn}"></span>
            <div class="langBox langBoxPosition" style="display: none">
              <div class="langImgs">
                <span class="ico lang ko" @click="setKorean()"></span>
                <span class="ico lang en" @click="setEnglish()"></span>
                <span class="ico lang ch" @click="setChinese()"></span>
              </div>
            </div>
          </div>
        </div>
        <div v-if="appFlag" class="mainStLstHome" @click="appMoveMain()"></div>
        <div v-if="appFlag" class="mainStLstMenu" @click="allMenuToggleChange()"></div>
      </div>
    </div>

    <div class="mainStLstContainer" @scroll="handleScroll()">
      <div class="mainStLstBg">
        <!-- <div class="mainStLstTit">
          <div class="mainStLstTitIco"></div>
          <p v-if="$i18n.locale == 'en'"><span>{{$t('QR.bestRestaurants')}}</span> {{$t('QR.registeredInTheOrder')}}</p>
          <p v-else>{{$t('QR.registeredInTheOrder')}}<span> {{$t('QR.bestRestaurants')}}</span></p>
        </div> -->

        <ul v-if="list.length > 0">
          <li class="mainStLst" v-for="(item,index) in list" :key="index" @click="reqQr(item.storeCode,item.menuExistFlag)">
            <div class="zone-left">
              <div class="comingSoon" v-if="item.menuExistFlag == 0">
                {{$t('QR.openingSoon')}}
              </div>
              <div class="alive" v-else-if="item.aliveFlag">
                <p>{{$t('QR.closed')}}</p>
              </div>
              <!-- storeImageUrl 이미지url을 이용해서 표시 -->
              <img v-if="item.storeImageUrl" :src="item.storeImageUrl">
              <!-- 기본이미지 -->
              <img v-else :src="defaultImg">
            </div>
            <!-- TODO : 2025-12-10 명동 포장 관련 임시, 아래 v-if 조건만 삭제 -->
            <div class="zone-right" v-if="!isTakeOutStoreIncluded(item.storeCode)">
              <!-- <img src="../assets/img/tag-onnuri-list.png" style="width:142px; height:24px; margin-bottom:4px;" v-if="item.serviceType">
              <p class="marketName" v-if="item.marketName">{{item.marketName}}</p> -->
              <p class="name">{{item.storeName}}</p>
              <p class="text">
                <span class="sp1">{{$t('QR.deliveryFee')}}</span>
                <template v-if="(item.from == 0 && item.to == 0) || item.deliveryFeeFlag">
                  <span></span>
                </template>
                <template v-else-if="item.from == item.to">
                  <span class="sp2" :class="{free:item.deliveryFeeFlag}">{{formatComma(item.from)}}원</span>
                </template>
                <template v-else>
                  <span class="sp2">{{formatComma(item.from)}}원 ~ {{formatComma(item.to)}}원</span>
                </template>
                <span class="freeTag" v-if="item.from == 0 && item.to == 0">무료</span>
                <span class="freeTag" v-else-if="item.deliveryFeeFlag">무료</span>
                <span class="distance" v-if="item.distance !== undefined"><img src="../assets/img/ic_distance.png" alt="">{{item.distance + 'km'}}</span>
                <span class="package" v-if="item.usePickup">{{$t('QR.toGoOK')}}</span>
              </p>
            </div>
            <!-- TODO : 2025-12-10 명동 포장 관련 임시, 아래 v-else 문 삭제 -->
            <div class="zone-right" v-else>
              <!-- <img src="../assets/img/tag-onnuri-list.png" style="width:142px; height:24px; margin-bottom:4px;" v-if="item.serviceType">
              <p class="marketName" v-if="item.marketName">{{item.marketName}}</p> -->
              <p class="name">{{item.storeName}}</p>
              <p class="info-box">
                <span class="package">{{$t('QR.toGoOK')}}</span>&nbsp;
                <span class="no-delivery">배달불가</span>
              </p>
            </div>
          </li>
          <template v-if="!isLastPage">
            <InfiniteLoading @infinite="appFlag ? storeList(true) : loadMore" />
          </template>
        </ul>
        <ul v-else>
          <div class="noFranchisee">
            <div class="noFranchiseeImg"></div>
            <p>지금은 주문할 수 있는<br>가게가 없습니다.</p>
          </div>
        </ul>
      </div>
    </div>
    <SingleBtnDialog
      v-if='showSingleBtnDialogFlag'
      :messageType='singleBtnMsgType'
      :onClickConfirmBtn='onClickConfirmBtn'
      :comingSoonFlag="true"/>
    <AppAllMenuPopup
      v-if="allMenuToggle"
      @allMenuToggleEmit="allMenuToggleChange"
      @pwdToggleChange="pwdToggleChange"/>
    <AppChangePassword
      v-if="pwdToggle"
      @pwdToggleChange="pwdToggleChange"
      @showSingleBtnDialog="showSingleBtnDialog"
      class="pop-top"
    />
  </div>
</template>

<script lang='js'>
import $ from 'jquery'
import SingleBtnDialog from '@/components/Dialog/SingleBtnDialog.vue'
import AppAllMenuPopup from '@/components/App/AppAllMenuPopup.vue'
import AppChangePassword from '@/views/AppChangePassword.vue'
import service from '@/backend/modnpay_app_api'
import InfiniteLoading from 'vue-infinite-loading'
export default {
  name: 'AppStoreList',
  components: {
    InfiniteLoading,
    SingleBtnDialog,
    AppAllMenuPopup,
    AppChangePassword
  },
  data () {
    return {
      groupQrData: JSON.parse(sessionStorage.getItem('GroupQrData')),
      categoryCode: sessionStorage.getItem('categoryCode'), // 음식 카테고리 코드
      addressByLotNum: sessionStorage.getItem('addressByLotNum'),
      tradition: JSON.parse(sessionStorage.getItem('tradition')),
      time: JSON.parse(sessionStorage.getItem('time')),
      page: 0, // 페이징 개수 (0부터 시작) (1회당 30개씩)
      list: [],
      isLastPage: '', // 마지막 페이지 여부
      isActive: false,
      address: '',
      showSingleBtnDialogFlag: false,
      singleBtnMsgType: 15,
      container: null,
      goBtnFlag: false,
      pwdToggle: false // 비밀번호 변경 팝업
    }
  },
  computed: {
    isKo () {
      return this.$i18n.locale === 'ko'
    },
    isEn () {
      return this.$i18n.locale === 'en'
    },
    isCn () {
      return this.$i18n.locale === 'cn'
    },
    defaultImg () { return require('../assets/img/list_img_empty.png') }
  },
  mounted () {
    window.backBtn = () => {
      this.backBtn()
    }
    this.container = document.querySelector('.mainStLstContainer')
    this.container.addEventListener('scroll', this.handleScroll)
    // window.addEventListener('scroll', this.handleScroll)
    this.address = sessionStorage.getItem('selectAddress')
    this.storeList(false)
  },
  beforeDestroy () {
    // 뒤로가기버튼 이벤트
    this.container.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    backBtn () {
      if (this.pwdToggle) {
        this.pwdToggle = !this.pwdToggle
      } else if (this.allMenuToggle) {
        this.allMenuToggleChange()
      } else {
        sessionStorage.removeItem('tradition')
        this.appMoveMain()
      }
    },
    pwdToggleChange () {
      this.pwdToggle = !this.pwdToggle
    },
    toggleLangBox () {
      $('.langNavi .langBox').fadeToggle(200)
    },
    setKorean () {
      this.$i18n.locale = 'ko'
      sessionStorage.setItem('langType', this.$i18n.locale)
      document.title = '모든오더'
      this.toggleLangBox()
      // this.$emit('reloadMainPage')
    },
    setEnglish () {
      this.$i18n.locale = 'en'
      sessionStorage.setItem('langType', this.$i18n.locale)
      document.title = '모든오더'
      this.toggleLangBox()
      // this.$emit('reloadMainPage')
    },
    setChinese () {
      this.$i18n.locale = 'cn'
      sessionStorage.setItem('langType', this.$i18n.locale)
      document.title = 'MODNPAY智慧点餐'
      this.toggleLangBox()
      // this.$emit('reloadMainPage')
    },
    async storeList (loadMoreCheck) {
      const parseAddress = JSON.parse(this.address)

      let req = {}
      if (parseAddress) {
        req = {
          townshipCode: this.appFlag ? parseAddress.townshipCode : parseAddress.admCd,
          orderGroupSeq: this.appFlag ? null : this.groupQrData.orderGroupSeq,
          categoryCode: this.categoryCode,
          traditionYn: this.tradition ? 'Y' : '',
          addressByLotNum: this.addressByLotNum,
          page: loadMoreCheck ? ++this.page : this.page,
          district: parseAddress.emdNm,
          gpsX: parseAddress.x !== undefined ? parseAddress.x : parseAddress.gpsX,
          gpsY: parseAddress.y !== undefined ? parseAddress.y : parseAddress.gpsY,
          time: this.time
        }
      } else {
        req = {
          orderGroupSeq: this.appFlag ? null : this.groupQrData.orderGroupSeq,
          categoryCode: this.categoryCode,
          traditionYn: this.tradition ? 'Y' : '',
          addressByLotNum: this.addressByLotNum,
          page: loadMoreCheck ? ++this.page : this.page,
          time: this.time
        }
      }
      const { data } = await service.groupQrStoreList(req)
      if (data.resultCode === 0) {
        this.loadMoreAdd(data, loadMoreCheck)
      }
    },
    loadMoreAdd (data, loadMoreCheck) {
      this.isLastPage = data.store.isLastPage
      // store.list.from, to 키 값이 없으면 키를 넣어주고 값은 0으로 넣어줌
      const storeList = data.store.list.map(item => {
        return {
          ...item,
          from: item.from ?? 0,
          to: item.to ?? 0
        }
      })
      if (!loadMoreCheck) {
        this.list = storeList
        sessionStorage.getItem('langType')
          ? this.$i18n.locale = sessionStorage.getItem('langType')
          : this.$i18n.locale = this.$store.getters.langType
      } else {
        this.list.push(...storeList)
      }
    },
    onClickConfirmBtn () {
      this.showSingleBtnDialogFlag = false
    },
    async reqQr (code, menuExistFlag) { // 매장 QR URL 요청
      const res = await service.storeIntroUrl({ urlCode: code })
      if (menuExistFlag === 0) {
        this.showSingleBtnDialogFlag = true
      } else if (res.data.resultCode === 0) {
        let baseUrl = res.data.introUrl
        const currentURL = window.location.href
        if (currentURL.indexOf('localhost') !== -1) {
          baseUrl = 'http://localhost:8004/menu/modn/mobile/ui/main?token=eyJ0b2tlbiI6ImQzMmU2NTlmLWQ3MGItNDM2Yy05YmNhLTNlNGE0ZmY5YzExYiIsIm9yZGVyU2VxIjoiMjMxMjAxMDA1MDYwNjIiLCJzdG9yZUNvZGUiOjI2MjYsInN0b3JlTmFtZSI6IuuqqOuToCDrtoTsi50iLCJvcmRlclRva2VuIjoiNDE0Mzc1MjEzYjEwNDUzNTA4MzU0MTljOWMxZmNmMTYxOTI1MmNiYzU4N2ViZDMzY2EiLCJ0YWJsZU5vIjotMSwiY2FyZENvZGUiOiIwMDAiLCJjcmVkaXQiOnRydWUsInFyVHlwZSI6MSwiYWxpdmUiOmZhbHNlfQ%3D%3D'
        }
        window.location.href = baseUrl// 가맹점 QR URL 리다이렉트하기
      } else {
        this.toast(this, res.data.resultMsg)
      }
    },
    async loadMore ($state) { // 무한스크롤
      const req = {
        orderGroupSeq: this.groupQrData.orderGroupSeq,
        categoryCode: this.categoryCode,
        addressByLotNum: this.addressByLotNum,
        page: ++this.page
      }
      const res = await service.storeListStep1(req)
      const resultCode = res.data.resultCode
      if (resultCode === 0) {
        const resIsLastPage = res.data.store.isLastPage
        this.isLastPage = resIsLastPage
        this.list.push(...res.data.store.list)
        $state.loaded()
      }
    },
    // handleScroll () {
    //   this.isActive = window.scrollY > 0
    // }
    handleScroll () {
      if (this.container && this.container.scrollTop > 0) {
        this.goBtnFlag = true
      } else {
        this.goBtnFlag = false
      }
    },
    scrollToTop () {
      if (this.container) {
        this.container.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      }
    },
    showSingleBtnDialog (message) {
      this.singleBtnMsgType = message
      this.onClickConfirmBtn = () => {
        this.pwdToggleChange()
        this.showSingleBtnDialogFlag = false
      }
      this.showSingleBtnDialogFlag = true
    }
  }
}
</script>
<style scoped>
/* body{height: calc(100% - 56px);} */
html,body,#app,#wrap{height: inherit !important;}
/* .main{padding: 56px 0 0 0;} */
.zone-left img{height: 64px; width: 64px;}
.header-title{top: 0;}
#wrap .main{padding-top:0}
.main{padding:0}
.groupQR-wrap{height: 100vh;}
.body-set{padding: 0;}
.sub-header{padding: 16px;}

.zone-right {
  margin-top: 0;
  .name {
    margin-bottom: 6px;
  }
  .package,
  .no-delivery,
  .freeTag {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0 6px;
    height: 20px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 700;
  }
  .package {
    background-color: #ffe4dc;
    color: var(--primary);
  }
  .no-delivery {
    background-color: #ececf2;
    color: #0d0d0d;
  }
  .info-box {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    column-gap: 4px;
    row-gap: 8px;
    .sp1,
    .sp2,
    .distance,
    .freeTag {
      margin-right: 0;
    }
  }
}
</style>
